module.exports = __webpack_public_path__ + "static/media/logo.9ce86185.svg";